import { PROJECT_SLUG } from '@monoimin/constants';

import { getDatasources } from './getDatasources';

import type { Locales, ProjectSlug } from '@monoimin/sb-types';

const programsSourceSlug: { [k in ProjectSlug]?: string } = {
  monoimin: 'programs',
  passportivity: 'psy-programs',
};

const sourceSlug = programsSourceSlug[PROJECT_SLUG];

/**
 * Получаем программы по странам. Используем эти данные на странице объекта и главной странице недвижимости.
 *
 * @param locale - Язык, служит постфиксом в слаге.
 */
export async function getStrapiPrograms(locale: Locales) {
  return getDatasources({
    locale: locale,
    filters: {
      slug: {
        $eq: `${sourceSlug}-${locale}`,
      },
    },
  }).then((res) => {
    if (res?.data?.length) {
      return res.data[0];
    }

    return null;
  });
}

export default getStrapiPrograms;
